// These mirror the values in "PermissionClaimType" in the ltps-api

export const APPLICATION_SETTINGS_VIEW = "ApplicationSettingsView";
export const ESTIMATOR_TEMPLATES_EDIT = "EstimatorTemplatesEdit";
export const ESTIMATOR_TEMPLATES_EXPORT = "EstimatorTemplatesExport";
export const EXCEPTION_LOGS_EXPORT = "ExceptionLogsExport";
export const EXCEPTION_LOGS_VIEW = "ExceptionLogsView";
export const INVOICES_EXPORT = "InvoicesExport";
export const LC_TASK_IMPORT_LEVY_PARAMETERS = "LcTaskImportLevyParameters";
export const LC_TASK_DELETE = "LcTaskDelete";
export const LC_TASK_FINALISE = "LcTaskFinalise";
export const LC_TASK_UPLOAD_OFFLINE_LEVY_PARAMETERS = "LcTaskUploadOfflineLevyParameters";
export const LC_TASK_IMPORT_IN_SCOPE_PROVIDERS = "LcTaskImportInScopeProviders";
export const LC_TASK_PUBLISH_PUBLIC_ESTIMATOR = "LcTaskPublishPublicEstimator";
export const LC_TASK_UNDO_FINALISATION = "LcTaskUndoFinalisation";
export const LC_TASK_REVERT_TO_COMMUNICATING = "LcTaskRevertToCommunicating";
export const LC_TASK_REVERT_TO_PREPARING = "LcTaskRevertToPreparing";
export const LC_TASK_START_COMMUNICATING = "LcTaskStartCommunicating";
export const LC_TASK_START_INVOICING = "LcTaskStartInvoicing";
export const LCP_TASK_EDIT_OVERRIDE = "LcpTaskEditOverride";
export const LCP_TASK_FAVOURITE = "LcpTaskFavourite";
export const LCP_TASK_FINALISE = "LcpTaskFinalise";
export const LCP_TASK_PAUSE = "LcpTaskPause";
export const LCP_TASK_RAISE_INVOICE = "LcpTaskRaiseInvoice";
export const LCP_TASK_REVERSE_INVOICE = "LcpTaskReverseInvoice";
export const LCP_TASK_SEND_ADDITIONAL_INFORMATION_SESSION_NOTICE = "LcpTaskSendAdditionalInformationSessionNotice";
export const LCP_TASK_SEND_ADHOC_NOTICE = "LcpTaskSendAdhocNotice";
export const LCP_TASK_SEND_EARLY_ADVICE_NOTICE = "LcpTaskSendEarlyAdviceNotice";
export const LCP_TASK_SEND_ESTIMATED_LEVY_NOTICE = "LcpTaskSendEstimatedLevyNotice";
export const LCP_TASK_SEND_INFORMATION_SESSION_NOTICE = "LcpTaskSendInformationSessionNotice";
export const LCP_TASK_SEND_INVOICE_NOTICE = "LcpTaskSendInvoiceNotice";
export const LCP_TASK_SEND_PAYMENT_DUE_REMINDER_NOTICE = "LcpTaskSendPaymentDueReminderNotice";
export const LCP_TASK_SEND_PAYMENT_OVERDUE_WARNING_NOTICE = "LcpTaskSendPaymentOverdueWarningNotice";
export const LCP_TASK_SEND_PAYMENT_RECEIPT_NOTICE = "LcpTaskSendPaymentReceiptNotice";
export const LCP_TASK_SET_PAYMENT_STATUS = "LcpTaskSetPaymentStatus";
export const LCP_TASK_UNDO_FINALISE = "LcpTaskUndoFinalise";
export const LEVY_COLLECTION_CONFIGURE_DATA_SOURCES = "LevyCollectionConfigureDataSources";
export const LEVY_COLLECTION_CONFIGURE_EMAIL = "LevyCollectionConfigureEmail";
export const LEVY_COLLECTION_CONFIGURE_FEES_AND_RATES = "LevyCollectionConfigureFeesAndRates";
export const LEVY_COLLECTION_CONFIGURE_INFORMATION_SESSIONS = "LevyCollectionConfigureInformationSessions";
export const LEVY_COLLECTION_CONFIGURE_INVOICE = "LevyCollectionConfigureInvoice";
export const LEVY_COLLECTION_CONFIGURE_PUBLIC_LEVY_ESTIMATOR = "LevyCollectionConfigurePublicLevyEstimator";
export const LEVY_COLLECTION_CONFIGURE_RISK_FACTORS = "LevyCollectionConfigureRiskFactors";
export const LEVY_COLLECTION_CONFIGURE_INVOICING_TIMING = "LevyCollectionConfigureInvoicingTiming";
export const LEVY_COLLECTION_CONFIGURE_LEVY_CALCULATION_TIMING = "LevyCollectionConfigureLevyCalculationTiming";
export const LEVY_COLLECTION_CREATE = "LevyCollectionCreate";
export const LEVY_COLLECTION_OVERRIDES_EXPORT = "LevyCollectionOverridesExport";
export const LEVY_COLLECTION_PROVIDERS_EXPORT = "LevyCollectionProvidersExport";
export const LEVY_COLLECTION_SANDBOXES = "LevyCollectionSandboxes";
export const LEVY_COLLECTION_UPLOAD_INSCOPE_PROVIDERS = "LevyCollectionUploadInScopeProviders";
export const LEVY_COLLECTION_UPLOAD_LEVY_CALCULATION_PARAMETERS = "LevyCollectionUploadLevyCalculationParameters";
export const NOTICE_TEMPLATES_EDIT = "NoticeTemplatesEdit";
export const NOTICE_TEMPLATES_EXPORT = "NoticeTemplatesExport";
export const NOTICES_EXPORT = "NoticesExport";
export const NOTICES_RESEND = "NoticesResend";
export const PROVIDER_NOTES_EDIT = "ProviderNotesEdit";
export const PROVIDER_PROMOTED_PRIMARY_CONTACTS_EDIT = "ProviderContactEditPromotedPrimaryContact";
export const PROVIDER_NOTSYNCED_CONTACT_STATUS_EDIT = "NotSyncedProviderContactStatusEdit";
export const PROVIDERS_EXPORT = "ProvidersExport";
export const ROLES_EDIT = "RolesEdit";
export const ROLES_VIEW = "RolesView";
export const SAP_DISMISS_RECONCILIATION_WARNING = "SapDismissReconciliationWarning";
export const SAP_RECONCILE = "SapReconcile";
export const SAP_TESTING = "SapTesting";
export const SCHEDULED_JOBS_EDIT = "ScheduledJobsEdit";
export const SCHEDULED_JOBS_VIEW = "ScheduledJobsView";
export const SYSTEM_LOGS_EXPORT = "SystemLogsExport";
export const SYSTEM_LOGS_VIEW = "SystemLogsView";
export const USERS_EXPORT = "UsersExport";
export const USERS_VIEW = "UsersView";
export const USERS_EDIT = "UsersEdit"
export const AUTHENTICATION_LOGS_VIEW = "UserAuthenticationLogsView";
export const AUTHENTICATION_LOGS_EXPORT = "UserAuthenticationLogsExport";
